import { appConfig } from '../../../../../../../../../config/customization';
import { socialIconSize } from '../../../../../../../../../constants/sizes';
import heartIcon from '../../../../assets/ic_favorite.png';
import heartIconLiked from '../../../../assets/ic_favorite_on.png';

const socialIcon = {
  width: socialIconSize,
  height: socialIconSize,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  display: 'flex'
};

export default {
  activeRowContent: {
    backgroundColor: appConfig.colors.activeRowColor,
    display: 'flex',
    // TODO: Use Row padding and remove width
    paddingLeft: 70,
    width: 'calc(100% - 70px)',
    boxShadow: 'inset -2px -73px 46px -87px rgba(0,0,0,1)',
    height: 120
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 60%',
    overflow: 'auto'
  },
  buttonContainer: {
    display: 'flex',
    flex: '1 0 10%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  socialIconHeart: {
    ...socialIcon,
    backgroundImage: `url(${heartIcon})`
  },
  socialIconHeartLiked: {
    ...socialIcon,
    backgroundImage: `url(${heartIconLiked})`
  }
};
